import { Grid } from '@mui/material';
import {
  TextField,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useState } from 'react';
import HOMA from '../../../../public/Images/Homa.png';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { LeftArrow } from '@HomaHealth/ui-component-library';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import ResetInstructionsInfo from '../../molecules/ResetInstructionsInfo';
import InfoBar from '../../atoms/InfoBar';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import Loader from '../../molecules/Loader';
import { RESET_PASSWORD } from '../../../core-utils/routes';

export interface ForgotPasswordOrganismProps {
  setIsForgotPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const ForgotPasswordOrganism: React.FC<ForgotPasswordOrganismProps> = ({
  setIsForgotPassword,
}) => {
  //constants
  const EMAIL_VALIDATION_REGEX =
    '^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,7}$';
  const constants = componentConstants.ORGANISMS.RESET_PASSWORD;

  // state variables
  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<boolean>(false);
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
  const [isResetApiFailed, setIsResetApiFailed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  //functions
  const handleTextChange = (e: any) => {
    const value = e.target.value as string;
    setEmail(value);
    setEmailError(false);
  };

  const handleSubmit = async () => {
    if (email?.match(EMAIL_VALIDATION_REGEX)) {
      setEmailError(false);
      setLoading(true);
      setIsResetApiFailed(false);
      await axios
        .post(
          properties.userManagementBaseUrl +
            properties.users +
            properties.sendEmail,
          {
            email: email,
            forgotPassword: true,
            redirectUrl: RESET_PASSWORD,
          },
        )
        .then(() => {
          setIsEmailSent(true);
        })
        .catch(() => {
          setIsResetApiFailed(true);
        });
      setLoading(false);
    } else {
      setEmailError(true);
    }
  };

  const handleKeyDown = (e: any) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div onKeyDown={handleKeyDown}>
      {loading ? (
        <Loader />
      ) : (
        <Grid
          container
          sx={{
            flexDirection: 'column',
          }}
        >
          <Grid
            container
            style={{ margin: '36px 0px', display: 'flex', cursor: 'pointer' }}
            onClick={() => setIsForgotPassword(false)}
            sx={{
              alignItems: 'center',
            }}
          >
            <Grid
              style={{
                height: '18px',
                width: '14px',
                marginRight: '12px',
              }}
            >
              <LeftArrow
                height="14px"
                width="14px"
                fill={patientAccessTheme.palette.text.mediumemphasis}
              />
            </Grid>

            <Typography
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontSize="14px"
              lineHeight="23px"
              fontType="medium"
            >
              {constants.GOTO_LOGIN}
            </Typography>
          </Grid>
          <Grid style={{ marginBottom: '20px' }}>
            <img src={HOMA} alt="HOMA" />
          </Grid>
          {isResetApiFailed && (
            <InfoBar info={constants.SOMETHING_WENT_WRONG} type="Error" />
          )}
          {isEmailSent ? (
            <ResetInstructionsInfo email={email} />
          ) : (
            <>
              <Grid style={{ marginBottom: '8px' }}>
                <Typography
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontSize="24px"
                  lineHeight="29px"
                  fontType="semiBold"
                >
                  {constants.FORGOT_PASSWORD_TITLE}
                </Typography>
              </Grid>
              <Grid style={{ marginBottom: '35px' }}>
                <Typography
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontSize="14px"
                  lineHeight="25px"
                >
                  {constants.FORGOT_PASSWORD_SUBTITLE}
                </Typography>
              </Grid>
              <Grid style={{ marginBottom: '48px' }}>
                <TextField
                  width="372px"
                  height="46px"
                  placeholder={'Email'}
                  onChange={(e: any) => handleTextChange(e)}
                  value={email}
                  error={emailError}
                  helperText={emailError ? constants.INVALID_EMAIL : ''}
                />
              </Grid>
              <Grid>
                <Button
                  label={
                    <Typography
                      textColor={patientAccessTheme.palette.status.white}
                      fontSize="16px"
                      lineHeight="24px"
                      fontType="semiBold"
                    >
                      {constants.RESET_PASSWORD}
                    </Typography>
                  }
                  variant="contained"
                  width="372px"
                  height="44px"
                  color="primary"
                  borderRadius="4px"
                  onClick={handleSubmit}
                  disabled={!email.length || emailError}
                />
              </Grid>
            </>
          )}
        </Grid>
      )}
    </div>
  );
};

export default ForgotPasswordOrganism;
